import { lazy, Suspense } from 'react';

const LazySearch = lazy(() => import("../search/Search"));

export const NonStaticSearch = ({ isStaticPage, props }) => {
	if (isStaticPage) {
		return null;
	}
	
	return (
		<Suspense fallback={null}>
			<LazySearch {...props} />
		</Suspense>
	);
};
